import { VFC } from 'react';

import { generateDefaultCodeSnippet } from 'dashboard/components/GridLayoutRender/computed-properties/helpers';
import MaximizableCodeEditor from 'dashboard/components/MaximizableCodeEditor';
import { generateJsonSchemaCompletionSource } from 'dashboard/components-lib/CodeEditor/completionSources/javascript/jsonSchemaCompletionSource';
import { ComputedProperty, CustomCode } from 'dashboard/lib/case-layouts/computed-properties';
import { JsonSchema, JsonSchemaObject } from 'lib/json-schema';

export interface CasesCustomCodeInput {
  dataSchema: JsonSchema;
  customCode: CustomCode;
  onSerializedCodeUpdate: (serializedCode: string) => void;
  returnType: ComputedProperty['return-type'];
}

export const CasesCustomCodeInput: VFC<CasesCustomCodeInput> = ({
  dataSchema,
  customCode,
  onSerializedCodeUpdate,
  returnType,
}) => {
  const deserializedCode = customCode['serialized-code']
    ? atob(customCode['serialized-code'])
    : generateDefaultCodeSnippet(
        returnType,
        'properties' in dataSchema ? dataSchema.properties : {},
      );

  const handleOnCodeUpdate = (code: string) => {
    onSerializedCodeUpdate(btoa(code));
  };

  return (
    <MaximizableCodeEditor
      code={deserializedCode}
      language='javascript'
      modalTitle='Evaluate Code'
      isOutsideClickDisabled={false}
      isReadOnly={false}
      onCodeUpdate={handleOnCodeUpdate}
      completionSources={{
        javascript: [generateJsonSchemaCompletionSource(dataSchema as JsonSchemaObject)],
      }}
    />
  );
};
